import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  notFound: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    textAlign: 'center'
  },
  paper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20vh',
    padding: theme.spacing(6, 10)
  }
}));

export default useStyles;
